<template>
  <div>
    <div class="wrapper">
      <b-row class="mt-2 mb-2">
        <b-col>
          <b-button class="pull-right" variant="primary" v-b-modal.create_faq>Veelgestelde vraag aanmaken</b-button>
        </b-col>
      </b-row>
      <div class="animated fadeIn">
        <resource-index header="Veelgestelde vragen" endpoint="faq" show-route="faq.view" />
      </div>
    </div>
    <b-modal id="create_faq" title="Veelgestelde vraag aanmaken" hide-footer>
      <b-form @submit.prevent="createItem">
        <b-form-group label="Vraag">
          <b-form-input type="text" required v-model="item.question"></b-form-input>
        </b-form-group>
        <hr>
        <b-button class="pull-left" variant="danger" @click="closeModal">Annuleer</b-button>
        <b-button type="submit" class="pull-right" variant="success">Maak veelgestelde vraag aan</b-button>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import ResourceIndex from '../../components/ResourceIndex';
import {addData} from "@/api";

export default {
  name: 'news',
  components: { ResourceIndex },
  data() {
    return {
      item: {
        question: null
      },
    }
  },
  methods: {
    async createItem() {
      const request = await addData('faq', {
        question: this.item.question
      }).then(response => response);

      if (request.status === 201) {
        return this.$router.push({ name: 'faq.view', params: {id: request.data.data.id}});
      }
    },
    closeModal() {
      this.$bvModal.hide('create_faq');
      this.item = {
        question: null,
      };
    }
  }
}

</script>
